import Box from '@mui/material/Box'
import LightGallery from 'lightgallery/react'
import axios from 'axios'
import Image from 'mui-image'
import { Notify } from 'notiflix/build/notiflix-notify-aio'
import { useEffect, useState, useCallback } from 'react'
// import Grid from '@mui/material/Grid'
import Container from '@mui/material/Container'
import Stack from '@mui/material/Stack'
// import NavigateNextIcon from '@mui/icons-material/NavigateNext'
// import NavigateBeforeIcon from '@mui/icons-material/NavigateBefore'
import ArrowCircleRightIcon from '@mui/icons-material/ArrowCircleRight'
import ArrowCircleLeftIcon from '@mui/icons-material/ArrowCircleLeft'
import Slide from '@mui/material/Slide'

// import styles
import 'lightgallery/css/lightgallery.css'
import 'lightgallery/css/lg-zoom.css'
import 'lightgallery/css/lg-thumbnail.css'

// import plugins if you need
import Heading from '../Heading'
// import arrowLeft from '../../assets/ArrowCircleLeft.svg'
import lgThumbnail from 'lightgallery/plugins/thumbnail'
import lgZoom from 'lightgallery/plugins/zoom'

import Loading from '../Loading'
import Button from '../Button'
import './styles/gallery.css'

export default function Gallery () {
  const [selectedAlbum, setSelecetedAlbum] = useState('gallery')
  const [galleries, setGalleries] = useState([])
  const [nazeFarms, setNazeFarms] = useState([])
  const [ngorOkpala, setNgorOkpala] = useState([])
  const [perPageGallery, setPerPageGallery] = useState(8)
  const [hasNextGallery, setHasNextGallery] = useState('')
  const [hasPreviousGallery, setHasPreviousGallery] = useState('')
  const [totalGallery, setTotalGallery] = useState('')
  const [currentPageGallery, setCurrentPageGallery] = useState(1)
  const [perPageNazeFarms, setPerPageNazeFarms] = useState(8)
  const [hasNextNazeFarms, setHasNextNazeFarms] = useState('')
  const [hasPreviousNazeFarms, setHasPreviousNazeFarms] = useState('')
  const [totalNazeFarms, setTotalNazeFarms] = useState('')
  const [currentPageNazeFarms, setCurrentPageNazeFarms] = useState(1)
  const [perPageNgorOkpala, setPerPageNgorOkpala] = useState(8)
  const [hasNextNgorOkpala, setHasNextNgorOkpala] = useState('')
  const [hasPreviousNgorOkpala, setHasPreviousNgorOkpala] = useState('')
  const [totalNgorOkpala, setTotalNgorOkpala] = useState('')
  const [currentPageNgorOkpala, setCurrentPageNgorOkpala] = useState(1)
  const [loading, setLoading] = useState(false)

  const getImages = useCallback(async () => {
    setLoading(true)
    const token = localStorage.getItem('adminOneculturToken')

    try {
      const getGalleryImages = await axios.get(
        `${
          process.env.REACT_APP_PROD_MODE === 'test'
            ? process.env.REACT_APP_API_URL_TEST
            : process.env.REACT_APP_API_URL_LIVE
        }/admin/new-get-images/gallery?page=${currentPageGallery}&perpage=${perPageGallery}`,
        {
          headers: {
            'x-auth-token': token
          }
        }
      )

      setHasNextGallery(getGalleryImages.data.pagination.hasNext)
      setHasPreviousGallery(getGalleryImages.data.pagination.hasPrevious)
      setCurrentPageGallery(getGalleryImages.data.pagination.currentPage)
      setTotalGallery(getGalleryImages.data.pagination.total)
      setGalleries([...getGalleryImages.data.allImages])

      const getGalleryNazeFarms = await axios.get(
        `${
          process.env.REACT_APP_PROD_MODE === 'test'
            ? process.env.REACT_APP_API_URL_TEST
            : process.env.REACT_APP_API_URL_LIVE
        }/admin/new-get-images/nazeFarms?page=${currentPageNazeFarms}&perpage=${perPageNazeFarms}`,
        {
          headers: {
            'x-auth-token': token
          }
        }
      )

      setHasNextNazeFarms(getGalleryNazeFarms.data.pagination.hasNext)
      setHasPreviousNazeFarms(getGalleryNazeFarms.data.pagination.hasPrevious)
      setCurrentPageNazeFarms(getGalleryNazeFarms.data.pagination.currentPage)
      setTotalNazeFarms(getGalleryNazeFarms.data.pagination.total)
      setNazeFarms([...getGalleryNazeFarms.data.allImages])

      const getGalleryNgorOkpala = await axios.get(
        `${
          process.env.REACT_APP_PROD_MODE === 'test'
            ? process.env.REACT_APP_API_URL_TEST
            : process.env.REACT_APP_API_URL_LIVE
        }/admin/new-get-images/ngorOkpala?page=${currentPageNgorOkpala}&perpage=${perPageNgorOkpala}`,
        {
          headers: {
            'x-auth-token': token
          }
        }
      )

      setHasNextNgorOkpala(getGalleryNgorOkpala.data.pagination.hasNext)
      setHasPreviousNgorOkpala(getGalleryNgorOkpala.data.pagination.hasPrevious)
      setCurrentPageNgorOkpala(getGalleryNgorOkpala.data.pagination.currentPage)
      setTotalNgorOkpala(getGalleryNgorOkpala.data.pagination.total)
      setNgorOkpala([...getGalleryNgorOkpala.data.allImages])
      Notify.success('Images fetched successfully')
    } catch (error) {
      Notify.failure('Server error, please try again.')
    }
    setLoading(false)
  }, [
    currentPageGallery,
    currentPageNgorOkpala,
    currentPageNazeFarms,
    perPageGallery,
    perPageNgorOkpala,
    perPageNazeFarms
  ])

  const handleChangeAlbum = album => setSelecetedAlbum(album)

  useEffect(() => {
    getImages()
  }, [
    getImages,
    currentPageNgorOkpala,
    currentPageGallery,
    currentPageNazeFarms
  ])

  const albums = {
    gallery: galleries,
    nazeFarms: nazeFarms,
    'ngor Okpala': ngorOkpala
  }

  const albumData = albums[selectedAlbum] || []

  console.log(
    'selectedAlbum',
    (selectedAlbum === 'gallery' && !hasPreviousGallery) ||
      (selectedAlbum === 'nazeFarms' && !hasPreviousNazeFarms) ||
      (selectedAlbum === 'ngor Okpala' && !hasPreviousNgorOkpala)
  )

  const isPreviousDisabled =
    (selectedAlbum === 'gallery' && !hasPreviousGallery) ||
    (selectedAlbum === 'nazeFarms' && !hasPreviousNazeFarms) ||
    (selectedAlbum === 'ngor Okpala' && !hasPreviousNgorOkpala)

  const isNextDisabled =
    (selectedAlbum === 'gallery' && !hasNextGallery) ||
    (selectedAlbum === 'nazeFarms' && !hasNextNazeFarms) ||
    (selectedAlbum === 'ngor Okpala' && !hasNextNgorOkpala)

  return (
    <Slide direction='left' in mountOnEnter unmountOnExit>
      <Box sx={{ backgroundColor: '#FBF7EC' }}>
        <Container
          sx={{
            paddingTop: '60px',
            minHeight: '100vh',
            paddingBottom: '60px'
          }}
          maxWidth='lg'
        >
          <Box
            sx={{
              display: 'flex',
              justifyContent: 'space-between',
              paddingBottom: '30px'
            }}
          >
            <Box>
              <Heading as='h1'
                fontWeight='bold'
                color='primary.main'
                fontSize={{ xs: '30px', md: '50px' }}
              >
                Gallery
              </Heading>
            </Box>
            <Box
              sx={{
                alignSelf: { md: 'center' }
              }}
            >
              <Stack
                direction='row'
                justifyContent='center'
                spacing={{ xs: 2, md: 5 }}
              >
                <ArrowCircleLeftIcon
                  onClick={() => {
                    if (isPreviousDisabled) return

                    if (selectedAlbum === 'gallery') {
                      setCurrentPageGallery(currentPageGallery - 1)
                    } else if (selectedAlbum === 'nazeFarms') {
                      setCurrentPageNazeFarms(currentPageNazeFarms - 1)
                    } else {
                      setCurrentPageNgorOkpala(currentPageNgorOkpala - 1)
                    }
                  }}
                  sx={{
                    alignSelf: 'center',
                    color: isPreviousDisabled ? 'grey' : 'primary.main',
                    fontSize: 30,
                    cursor: isPreviousDisabled ? 'not-allowed' : 'pointer',
                    pointerEvents: isPreviousDisabled ? 'none' : 'auto'
                  }}
                />
                <ArrowCircleRightIcon
                  onClick={() => {
                    if (isNextDisabled) return

                    if (selectedAlbum === 'gallery') {
                      setCurrentPageGallery(currentPageGallery + 1)
                    } else if (selectedAlbum === 'nazeFarms') {
                      setCurrentPageNazeFarms(currentPageNazeFarms + 1)
                    } else {
                      setCurrentPageNgorOkpala(currentPageNgorOkpala + 1)
                    }
                  }}
                  sx={{
                    alignSelf: 'center',
                    color: isNextDisabled ? 'grey' : 'primary.main',
                    fontSize: 30,
                    cursor: isNextDisabled ? 'not-allowed' : 'pointer',
                    pointerEvents: isNextDisabled ? 'none' : 'auto'
                  }}
                />
              </Stack>
            </Box>
          </Box>
          <Stack
            sx={{
              display: { xs: 'flex' },
              justifyContent: 'center',
              paddingTop: '20px',
              paddingBottom: '14px'
            }}
            direction='row'
            spacing={2}
          >
            <Button
              onClick={() => handleChangeAlbum('gallery')}
              variant='contained'
              text='All'
              borderRadius='0px'
              backgroundColor={
                selectedAlbum === 'gallery' ? 'primary.main' : 'transparent'
              }
              color={selectedAlbum === 'gallery' ? 'white' : 'black'}
              fontFamily='Fira Code'
            />
            <Button
              onClick={() => handleChangeAlbum('nazeFarms')}
              variant='contained'
              text='Naze Farms'
              borderRadius='0px'
              backgroundColor={
                selectedAlbum === 'nazeFarms' ? 'primary.main' : 'transparent'
              }
              color={selectedAlbum === 'nazeFarms' ? 'white' : 'black'}
              fontFamily='Fira Code'
            />
            <Button
              onClick={() => handleChangeAlbum('ngor Okpala')}
              variant='contained'
              text='Ngor Okpala'
              borderRadius='0px'
              backgroundColor={
                selectedAlbum === 'ngor Okpala' ? 'primary.main' : 'transparent'
              }
              color={selectedAlbum === 'ngor Okpala' ? 'white' : 'black'}
              fontFamily='Fira Code'
            />
          </Stack>

          {loading && (
            <Box sx={{ minHeight: '100vh' }}>
              <Loading />
            </Box>
          )}
          <Box
            sx={{
              display: 'flex',
              justifyContent: 'center',
              minHeight: '100vh'
            }}
          >
            {!loading && albumData.length > 0 && (
              <LightGallery speed={500} plugins={[lgThumbnail, lgZoom]}>
                {albumData.map(({ image, text, title }, index) => (
                  <a key={index} href={image}>
                    <Image width='100%' alt={text} src={image} />
                    <Box sx={{ color: 'black' }}>{title}</Box>
                  </a>
                ))}
              </LightGallery>
            )}
          </Box>
          <Box
            sx={{
              paddingTop: '30px',
              display: 'flex',
              justifyContent: 'center',
              alignSelf: { md: 'center' }
            }}
          >
            <Stack
              direction='row'
              justifyContent='center'
              spacing={{ xs: 2, md: 5 }}
            >
              <ArrowCircleLeftIcon
                onClick={() => {
                  if (isPreviousDisabled) return

                  if (selectedAlbum === 'gallery') {
                    setCurrentPageGallery(currentPageGallery - 1)
                  } else if (selectedAlbum === 'nazeFarms') {
                    setCurrentPageNazeFarms(currentPageNazeFarms - 1)
                  } else {
                    setCurrentPageNgorOkpala(currentPageNgorOkpala - 1)
                  }
                }}
                sx={{
                  alignSelf: 'center',
                  color: isPreviousDisabled ? 'grey' : 'primary.main',
                  fontSize: 30,
                  cursor: isPreviousDisabled ? 'not-allowed' : 'pointer',
                  pointerEvents: isPreviousDisabled ? 'none' : 'auto'
                }}
              />
              <ArrowCircleRightIcon
                onClick={() => {
                  if (isNextDisabled) return

                  if (selectedAlbum === 'gallery') {
                    setCurrentPageGallery(currentPageGallery + 1)
                  } else if (selectedAlbum === 'nazeFarms') {
                    setCurrentPageNazeFarms(currentPageNazeFarms + 1)
                  } else {
                    setCurrentPageNgorOkpala(currentPageNgorOkpala + 1)
                  }
                }}
                sx={{
                  alignSelf: 'center',
                  color: isNextDisabled ? 'grey' : 'primary.main',
                  fontSize: 30,
                  cursor: isNextDisabled ? 'not-allowed' : 'pointer',
                  pointerEvents: isNextDisabled ? 'none' : 'auto'
                }}
              />
            </Stack>
          </Box>
        </Container>
      </Box>
    </Slide>
  )
}
